import React, { useEffect, useState } from "react";
import { useParams, useNavigate, useLocation } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import jsPDF from "jspdf";
import "../assets/Loan/GroupLoanEmiDetails.css";
import { fetchUserProfile } from "../redux/slices/branch/userProfileSlice";
import axios from "axios";
import { toast } from "react-toastify";

const GoldLoanEmiDetails = () => {
  // const isMounted = useRef(false);
  const { loanId } = useParams();
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const location = useLocation();
  const loan = location.state?.loan;

  const [emis, setemis] = useState([]);
  const [currentPage, setCurrentPage] = useState(null);
  const [totalPages, setTotalPages] = useState(1);
  const [count, setcount] = useState(0);
  const [modalopen,setmodalopen] =useState(false);

  const { profile } = useSelector((state) => state.userProfile);

  const [company, setCompany] = useState(null);
  const [showModal, setShowModal] = useState(false);
  const [selectedEmi, setSelectedEmi] = useState(null);
  const [submitting, setSubmitting] = useState(false);
  const [currentmonthInterest,setCurrentMonthInterest]=useState(0);

  const [paymentData, setPaymentData] = useState({
    amountPaid: "",
    paymentMode: "Cash",
    paymentDate: new Date().toISOString().split("T")[0],
    remark: "",
  });

  const [previewUrl, setPreviewUrl] = useState(null);
  const [showPreview, setShowPreview] = useState(false);
  const [collectionData, setCollectionData] = useState({
      goldLoanId: loan?.id || loanId,
      collectionType: "PRINCIPAL",
      principalAmount: "",
      interestAmount: "",
      paymentMode: "CASH",
      collectedBy: profile?.id,
      remarks: "",
    });

  const handleCollectionChange = (field, value) => {
      setCollectionData((prev) => ({
        ...prev,
        [field]: value,
      }));
    };

  const handleCollectionSubmit = async () => {
      try {
        setSubmitting(true);

        const payload = {
          goldLoanId: loan?.id,
          collectionType: collectionData.collectionType,
          principalAmount:
            collectionData.collectionType !== "INTEREST"
              ? Number(collectionData.principalAmount || 0)
              : 0,
          interestAmount:
            collectionData.collectionType !== "PRINCIPAL"
              ? Number(collectionData.interestAmount || 0)
              : 0,
          paymentMode: collectionData.paymentMode,
          collectedBy: profile?.id,
          remarks: collectionData.remarks,
        };

        await axios.post(
          "https://payyug.in/api/gold-loan/pay/manual",
          payload
        );

        toast.success("✅ Collection Successful");
        setmodalopen(false);
        fetchemis();
      } catch (err) {
        toast.error("❌ Collection Failed");
      } finally {
        setSubmitting(false);
      }
    };

  useEffect(() => {
    dispatch(fetchUserProfile());
  }, [dispatch]);

  useEffect(() => {
    // fetchemis();
    if (profile?.superAdminId) fetchCompany();
  }, [loanId, profile?.superAdminId]);

  useEffect(() => {
    if(currentPage!=null)
      fetchemis();
  }, [currentPage]);

  const fetchCompany = async () => {
    try {
      const res = await fetch(
        `https://payyug.in/api/get-company?superAdminId=${profile?.superAdminId}`
      );
      const data = await res.json();
      if (data?.logo) {
        data.logoUrl = `https://payyug.in/${data.logo.replace(/^images\//, "")}`;
      }
      setCompany(data);
    } catch (err) {
      console.error(err);
    }
  };

  // const fetchemis = async (page = currentPage) => {
  //   try {
  //     const res = await axios.get(`https://payyug.in/api/gold-loan/emis/all/${loan.id}`, {
  //       params: {
  //         superAdminId: profile.superAdminId,
  //         page,
  //         limit: 10,
  //       },
  //     });

  //     console.log('emis data',res.data)
  //     setemis(res.data?.data || []);
  //     setTotalPages(res.data.pagination.totalPages || 1);
  //     setcount(res.data.pagination.totalRecords || 0);
  //   } catch (err) {
  //     console.error(err);
  //   }
  // };
  
  const fetchemis = async (page = currentPage) => {
    try {
      const res = await axios.get(
        "https://payyug.in/api/gold-loan/manual-collections/pay",
        {
          params: {
            superAdminId: profile?.superAdminId,
            branchId: profile?.branchId,     
            employeeId: profile?.id,
            // fromDate: "2025-01-01",           
            // toDate: new Date().toISOString().split("T")[0],
            goldLoanId:loan?.id,
            page,
            limit: 10,
          },
        }
      );

      console.log("manual collection data", res.data);

      setemis(res.data?.data || []);
      setTotalPages(res.data?.pagination?.totalPages || 1);
      setcount(res.data?.pagination?.totalRecords || 0);
    } catch (err) {
      console.error(err);
    }
  };

  useEffect(()=> {
    if(!profile)
      return;
    fetchemis();
  },[profile]);

  const handlePayClick = (emi) => {
    setSelectedEmi(emi);
    setPaymentData({
      amountPaid: emi.emiAmount,
      paymentMode: "Cash",
      paymentDate: new Date().toISOString().split("T")[0],
      remark: "",
    });
    setShowModal(true);
  };

  const handleSubmitPayment = async () => {
    if (!selectedEmi) return;

    try {
      setSubmitting(true);

      const payload = {
        // emiId: selectedEmi.id,
        paymentAmount: paymentData.amountPaid,
        paymentMode: paymentData.paymentMode,
        // paidDate: paymentData.paymentDate,
        collectedBy: profile.id,
        // remark: paymentData.remark,
      };

      await axios.post(`https://payyug.in/api/gold-loan/pay-loan/${selectedEmi.id}`, payload);
      toast.success("✅ Payment Successful");
      fetchemis();
      setShowModal(false);
    } catch {
      toast.error("❌ Payment Failed");
    } finally {
      setSubmitting(false);
    }
  };

  useEffect(()=> {
    if(!loan)
       return;
    var interest=(loan?.loanRoi*loan?.loanAmount)/100;
    setCurrentMonthInterest(interest/12);
  },[loan])

  const formatDate = (d) =>
    d ? new Date(d).toLocaleDateString("en-GB") : "-";

  const formatCurrency = (n) =>
    `Rs. ${Number(n || 0).toLocaleString("en-IN", {
      minimumFractionDigits: 2,
    })}`;

  const loadLogoAsDataURL = (src) =>
    new Promise((resolve) => {
      if (!src) return resolve(null);
      const img = new Image();
      img.crossOrigin = "anonymous";
      img.onload = () => {
        const canvas = document.createElement("canvas");
        canvas.width = img.width;
        canvas.height = img.height;
        canvas.getContext("2d").drawImage(img, 0, 0);
        resolve(canvas.toDataURL("image/png"));
      };
      img.onerror = () => resolve(null);
      img.src = src;
    });

  const buildEmiSlipPDF = async (emi) => {
    if ((emi.status || "").toLowerCase() !== "paid") {
      toast.warn("Slip available only for PAID EMI");
      return null;
    }

    const doc = new jsPDF({ unit: "pt", format: "a4" });
    const pageWidth = doc.internal.pageSize.getWidth();
    const margin = 40;

    const logoDataURL = await loadLogoAsDataURL(
      company?.logoUrl || "/techvisionlogo.jpg"
    );

    if (logoDataURL) {
      doc.addImage(logoDataURL, "PNG", margin, margin, 65, 65);
    }

    doc.setFont("helvetica", "bold").setFontSize(20);
    doc.text(
      company?.name || "TechVision Finance",
      margin + 80,
      margin + 22
    );

    doc.setFont("helvetica", "normal").setFontSize(11);
    doc.text(
      `Email: ${company?.email || "-"} | Phone: ${company?.contact || "-"}`,
      margin + 80,
      margin + 42
    );

    doc.setFont("helvetica", "bold").setFontSize(15);
    doc.text("EMI Payment Slip", margin, margin + 95);

    let y = margin + 125;

    const leftInfo = [
      ["Customer Name", loan.memberName],
      ["Loan Account No", loan.loanAccountNumber],
      ["EMI No", emi.installmentNo],
    ];

    const rightInfo = [
      ["Paid Date", formatDate(emi.paidDate)],
      ["Due Date", formatDate(emi.dueDate)],
      ["Payment Mode", emi.payment1Mode || "-"],
    ];

    doc.setFontSize(12).setFont("helvetica", "bold");

    leftInfo.forEach(([label, value], i) => {
      doc.text(`${label}:`, margin, y + i * 20);
      doc.setFont("helvetica", "normal");
      doc.text(String(value || "-"), margin + 130, y + i * 20);
      doc.setFont("helvetica", "bold");
    });

    rightInfo.forEach(([label, value], i) => {
      doc.text(`${label}:`, pageWidth / 2, y + i * 20);
      doc.setFont("helvetica", "normal");
      doc.text(String(value || "-"), pageWidth / 2 + 130, y + i * 20);
      doc.setFont("helvetica", "bold");
    });

    y += 80;

    const emiDetails = [
      ["EMI Amount", formatCurrency(emi.emiAmount)],
      ["Payment Status", emi.status],
    ];

    emiDetails.forEach(([label, value], i) => {
      doc.setFont("helvetica", "bold");
      doc.text(label, margin, y + i * 22);
      doc.setFont("helvetica", "normal");
      doc.text(String(value || "-"), pageWidth / 2, y + i * 22);
    });

    y += 60;

    doc.setFont("helvetica", "bold").setFontSize(13);
    doc.text("Outstanding Balance:", margin, y);
    doc.setFont("helvetica", "normal");
    doc.text(
      formatCurrency(emi.outstanding || 0),
      pageWidth / 2,
      y
    );

    y += 50;

    doc.setFont("helvetica", "italic").setFontSize(10);
    doc.text(
      "This is a system-generated EMI slip. No signature required.",
      margin,
      y
    );

    return doc;
  };

  const generateEmiSlipPDF = async (emi) => {
    const doc = await buildEmiSlipPDF(emi);
    if (doc) doc.save(`EMI_Slip_${loan.loanAccountNumber}_${emi.installmentNo}.pdf`);
  };

  const previewEmiSlipPDF = async (emi) => {
    const doc = await buildEmiSlipPDF(emi);
    if (!doc) return;
    const url = URL.createObjectURL(doc.output("blob"));
    setPreviewUrl(url);
    setShowPreview(true);
  };

  return (
    <div className="viewemiloandata-container">
      <header className="viewemiloandata-headerbar">
        <div className="viewemiloandata-company">
          <img
            src={company?.logoUrl || "/techvisionlogo.jpg"}
            alt="Company Logo"
            className="viewemiloandata-logo"
          />
          <div className="viewemiloanddata-company-details">
            <h2 className="viewemiloandata-companyname">
              {company?.name || "TechVision Finance"}
            </h2>
            <p>
              <strong>Email:</strong> {company?.email} 
            </p>
            <p>
              <strong>Phone:</strong> {company?.contact}
            </p>
          </div>
        </div>
      </header>

      <div className="viewemiloandata-loaninfo">
        <h3>Loan & Customer Details</h3>
        <p>
          <strong>Customer Name:</strong> {loan.userName}
        </p>
        <p>
          <strong>Loan Account No:</strong> {loan.loanAccountNumber}
        </p>
        <p>
          <strong>Total EMIs:</strong> {count}
        </p>
         <p>
          <strong>Current Month Interest:</strong> {currentmonthInterest.toFixed(2)}
        </p>
      </div>

      <div className="viewemiloandata-table-container">
        <div className="table-top-title-gold">
           <h3>Loan EMI Schedule</h3>
           <button className="btn-add-payment" 
                   onClick={() => {
                    setmodalopen(true);
                    setCurrentPage(1)}
            }>Add Payment</button>
        </div>

        {/* <table className="viewemiloandata-table">
          <thead>
            <tr>
              <th>EMI No</th>
              <th>Due Date</th>
              <th>Amount</th>
              <th>Status</th>
              <th>Paid Date</th>
              <th>Action</th>
              <th>Slip</th>
            </tr>
          </thead>

          <tbody>
            {emis.length > 0 ? (
              emis.map((emi, i) => {
                const isPaid = emi.status?.toLowerCase() === "paid";
                const isPartial = emi.status?.toLowerCase() === "partial";
                const isPending = emi.status?.toLowerCase() === "pending";
                const nextEmi = i < emis.length - 1 ? emis[i + 1] : null;
                return (
                  <tr
                    key={emi.id}
                    className="emi-row"
                    style={{
                      background: isPaid
                        ? "#e8f7e8"
                        : isPartial
                        ? "#fff6e0"
                        : "#ffecec",
                    }}
                  >
                    <td>{emi.emiNumber || emi.installmentNo}</td>
                    <td>{formatDate(emi.dueDate)}</td>
                    <td>
                      {formatCurrency(emi.emiAmount)}
                      <div className="emi-small">
                        <span>Principal: {formatCurrency(emi.principalComponent)}</span>
                        <br />
                        <span>Interest: {formatCurrency(emi.interestComponent)}</span>
                      </div>
                    </td>
                    <td style={{ fontWeight: "bold" }}>
                      {isPaid && <span style={{ color: "green" }}>Paid</span>}
                      {isPartial && <span style={{ color: "#ff9800" }}>Partial</span>}
                      {isPending && <span style={{ color: "red" }}>Pending</span>}

                      {isPartial && (
                        <div className="emi-small">
                          Paid: {formatCurrency(emi.partiallyPaidAmount)} <br />
                          Remaining: {formatCurrency(emi.emiBalance)}
                        </div>
                      )}

                      {isPaid && emi.lastPaidAmount && (
                        <div className="emi-small">
                          Last Paid: {formatCurrency(emi.lastPaidAmount)}
                        </div>
                      )}

                      <div className="emi-small">
                        Outstanding: {formatCurrency(emi.outstanding)}
                      </div>
                    </td>
                    <td>{emi.lastPaidDate ? formatDate(emi.lastPaidDate) : "-"}</td>
                    <td>
                      {isPaid ? (
                        <span style={{ color: "green", fontWeight: "bold" }}>✔ Paid</span>
                      ) : (
                        <div className="emi-actions">
                          <button className="btn-full" onClick={() => handlePayClick(emi)}>
                            Pay 
                          </button>
                        </div>
                      )}
                    </td>
                    <td>
                      {isPaid ? (
                        <button
                          className="grouploanemidetails-emi-reciept"
                          onClick={() =>
                            navigate("/goldloan/goldLoanReport/goldLoanEmiDetails/reciept", {
                              state: { emi, loan, nextEmi },
                            })
                          }
                        >
                          Receipt
                        </button>
                      ) : (
                        <span style={{ color: "gray" }}>After Payment</span>
                      )}
                    </td>
                  </tr>
                );
              })
            ) : (
             
              <tr>
                <td colSpan="7" style={{ textAlign: "center", padding: "30px", color: "#666" }}>
                  <strong>No EMIs found</strong>
                </td>
              </tr>
            )}
          </tbody>
        </table> */}
        <table>
          <thead>
            <tr>
              <th>#</th>
              <th>Collection Date</th>
              <th>Amount</th>
              <th>Status</th>
              <th>Created At</th>
              <th>Action</th>
              <th>Slip</th>
            </tr>
          </thead>
          <tbody>
            {emis.length > 0 ? (
              emis.map((emi, i) => {
                return (
                  <tr key={emi.id} className="emi-row" style={{ background: "#e8f7e8" }}>
                    
                    {/* Serial No (instead of EMI No) */}
                    <td>{i + 1}</td>

                    {/* Collection Date */}
                    <td>{formatDate(emi.collectionDate)}</td>

                    {/* Amount */}
                    <td>
                      {formatCurrency(emi.totalAmount)}
                      <div className="emi-small">
                        <span>
                          Principal: {formatCurrency(emi.principalAmount)}
                        </span>
                        <br />
                        <span>
                          Interest: {formatCurrency(emi.interestAmount)}
                        </span>
                      </div>
                    </td>

                    {/* Status */}
                    <td style={{ fontWeight: "bold", color: "green" }}>
                      Collected
                      <div className="emi-small">
                        Type: {emi.collectionType}
                      </div>
                    </td>

                    {/* Paid Date */}
                    <td>{formatDate(emi.createdAt)}</td>

                    {/* Action */}
                    <td>
                      <span style={{ color: "green", fontWeight: "bold" }}>
                        ✔ Done
                      </span>
                    </td>

                    {/* Receipt */}
                    <td>
                      <button
                        className="grouploanemidetails-emi-reciept"
                        onClick={() =>
                          navigate(
                            "/goldloan/goldLoanReport/goldLoanEmiDetails/reciept",
                            {
                              state: { emi, loan },
                            }
                          )
                        }
                      >
                        Receipt
                      </button>
                    </td>
                  </tr>
                );
              })
            ) : (
              <tr>
                <td
                  colSpan="7"
                  style={{ textAlign: "center", padding: "30px", color: "#666" }}
                >
                  <strong>No Collection Data Found</strong>
                </td>
              </tr>
            )}
          </tbody>
        </table>
       
      </div>

      
      {showModal && (
        <div className="viewemiloandata-modal-overlay">
          <div className="viewemiloandata-modal">
            <h3>
              {paymentData.type === "full" &&
                `Pay Full EMI (No: ${selectedEmi?.emiNumber})`}
              {paymentData.type === "partial" &&
                `Partial Payment (No: ${selectedEmi?.emiNumber})`}
              {paymentData.type === "advance" &&
                `Advance EMI Payment (No: ${selectedEmi?.emiNumber})`}
            </h3>

            {paymentData.type === "partial" && (
              <p style={{ color: "red", fontWeight: "bold" }}>
                Note: Partial payment accepted. Remaining amount will stay
                pending.
              </p>
            )}

            <label>
              Amount:
              <input
                type="number"
                value={paymentData.amountPaid}
                onChange={(e) =>
                  setPaymentData({
                    ...paymentData,
                    amountPaid: e.target.value,
                  })
                }
              />
            </label>

            <label>
              Mode:
              <select
                value={paymentData.paymentMode}
                onChange={(e) =>
                  setPaymentData({
                    ...paymentData,
                    paymentMode: e.target.value,
                  })
                }
              >
                <option value="Cash">Cash</option>
                <option value="Card">Card</option>
                <option value="UPI">UPI</option>
                <option value="NetBanking">Net Banking</option>
              </select>
            </label>

            <label>
              Date:
              <input
                type="date"
                value={paymentData.paymentDate}
                onChange={(e) =>
                  setPaymentData({
                    ...paymentData,
                    paymentDate: e.target.value,
                  })
                }
              />
            </label>

            <label>
              Remark:
              <input
                type="text"
                value={paymentData.remark}
                onChange={(e) =>
                  setPaymentData({
                    ...paymentData,
                    remark: e.target.value,
                  })
                }
              />
            </label>

            <div className="modal-actions">
              <button onClick={() => setShowModal(false)}>Cancel</button>
              <button
                onClick={handleSubmitPayment}
                disabled={submitting}
              >
                {submitting ? "Processing..." : "Confirm"}
              </button>
            </div>
          </div>
        </div>
      )}

      {modalopen && (
        <div className="viewemiloandata-modal-overlay">
          <div className="viewemiloandata-modal">
            <h3>Manual Collection</h3>

            {/* Collection Type */}
            <label>
              Collection Type:
              <select
                value={collectionData.collectionType}
                onChange={(e) =>
                  handleCollectionChange("collectionType", e.target.value)
                }
              >
                <option value="PRINCIPAL">Principal</option>
                <option value="INTEREST">Interest</option>
                <option value="BOTH">Both</option>
              </select>
            </label>

            {/* Principal Input */}
            {(collectionData.collectionType === "PRINCIPAL" ||
              collectionData.collectionType === "BOTH") && (
              <label>
                Principal Amount:
                <input
                  type="number"
                  value={collectionData.principalAmount}
                  onChange={(e) =>
                    handleCollectionChange("principalAmount", e.target.value)
                  }
                />
              </label>
            )}

            {/* Interest Input */}
            {(collectionData.collectionType === "INTEREST" ||
              collectionData.collectionType === "BOTH") && (
              <label>
                Interest Amount:
                <input
                  type="number"
                  value={collectionData.interestAmount}
                  onChange={(e) =>
                    handleCollectionChange("interestAmount", e.target.value)
                  }
                />
              </label>
            )}

            {/* Payment Mode */}
            <label>
              Payment Mode:
              <select
                value={collectionData.paymentMode}
                onChange={(e) =>
                  handleCollectionChange("paymentMode", e.target.value)
                }
              >
                <option value="CASH">Cash</option>
                <option value="UPI">UPI</option>
                <option value="CARD">Card</option>
                <option value="NETBANKING">Net Banking</option>
              </select>
            </label>

            {/* Remarks */}
            <label>
              Remarks:
              <input
                type="text"
                value={collectionData.remarks}
                onChange={(e) =>
                  handleCollectionChange("remarks", e.target.value)
                }
              />
            </label>

            <div className="modal-actions">
              <button onClick={() => setmodalopen(false)}>Cancel</button>
              <button onClick={handleCollectionSubmit} disabled={submitting}>
                {submitting ? "Processing..." : "Submit"}
              </button>
            </div>
          </div>
        </div>
      )}

      {showPreview && previewUrl && (
        <div className="viewemiloandata-modal-overlay">
          <div
            className="viewemiloandata-modal"
            style={{ width: "80%", height: "90%" }}
          >
            <h3>Slip Preview</h3>
            <iframe
              src={previewUrl}
              style={{
                width: "100%",
                height: "80%",
                border: "none",
              }}
            />
            <div className="modal-actions">
              <button
                onClick={() => {
                  setShowPreview(false);
                  URL.revokeObjectURL(previewUrl);
                }}
              >
                Close
              </button>
            </div>
          </div>
        </div>
      )}

     <div className="account-ledger-list-pagination-section">
        <div className="account-ledger-list-pagination-div">
          <button
            onClick={() => setCurrentPage(currentPage - 1)}
            disabled={currentPage === 1}
          >
            ⬅ Prev
          </button>
          <span>
            Page {currentPage} of {totalPages}
          </span>
          <button
            onClick={() => setCurrentPage(currentPage + 1)}
            disabled={currentPage === totalPages}
          >
            Next ➡
          </button>
        </div>
      </div>

      <footer className="viewemiloandata-footer">
        <p>© 2025 {company?.name || "TechVision Finance"} Pvt. Ltd.</p>
        <p>{company?.tagline || "Empowering Dreams"}</p>
      </footer>
    </div>
  );
};

export default GoldLoanEmiDetails;